import { general } from './general';
import { countryString } from '../../validators/location';
import { branch } from './branch';
import { notapplicable } from './notapplicable';

/**
 *
 * @param {LocationModel} data
 * @returns
 */
export const location = (data = {}) => general('location', {
  ...(data || {}),
  apoFpoNotApplicable: notapplicable((data || {}).apoFpoNotApplicable),
  cityUnknown: notapplicable((data || {}).cityUnknown),
  country: countryString((data || {}).country),
  countryNotApplicable: notapplicable((data || {}).countryNotApplicable),
  isMilitaryDiplomaticAddress: branch((data || {}).isMilitaryDiplomaticAddress),
  militaryInstallationNameNotApplicable: notapplicable((data || {}).militaryInstallationNameNotApplicable),
  stateUnknown: notapplicable((data || {}).stateUnknown),
  streetUnknown: notapplicable((data || {}).streetUnknown),
  zipcodeUnknown: notapplicable((data || {}).zipcodeUnknown),
});
